export { TextWithLangLinks } from './text-with-lang-links';
